import { render, staticRenderFns } from "./StartWorkflowFileUpload.vue?vue&type=template&id=04a23af4&scoped=true&"
import script from "./StartWorkflowFileUpload.vue?vue&type=script&lang=js&"
export * from "./StartWorkflowFileUpload.vue?vue&type=script&lang=js&"
import style0 from "./StartWorkflowFileUpload.vue?vue&type=style&index=0&id=04a23af4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a23af4",
  null
  
)

export default component.exports